import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import '@/styles/index.scss'
import store from './store'
import router from './router'
import { request } from './utils/request'

import Storage from 'vue-ls'
import requestUrl from './api/index'
// import wx from 'weixin-js-sdk'
import * as ww from '@wecom/jssdk'
import './permission'
// import RightMenu from '@/views/customer'
// vue-ls 的配置
const storageOptions = {
    namespace: 'fk_', // key 键的前缀（随便起）
    name     : 'ls', // 变量名称（随便起） 使用方式：Vue.变量名称 或 this.$变量名称
    storage  : 'local' // 作用范围：local、session、memory
}

Vue.config.productionTip = false
Vue.use(Storage, storageOptions)
Vue.prototype.$requestUrl = requestUrl
Vue.use(Vant)

new Vue({
    el    : '#app',
    router,
    store,
    render: h => {
        window.$request = request
        window.$wx = ww
        return h(App)
    }
})
